import React, { useState, useEffect, memo } from 'react';
import "react-simple-keyboard/build/css/index.css";
import { kioskLoginActions } from '../../_store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/inmate-white-logo.png';
import CustomModal from '../../components/common/CustomModal ';
import kioskSetupSchema from '../../validation/kioskSetupSchema';
import SelectInput from '../../components/common/ui/Inputs/SelectInput';
import Button from '../../components/common/ui/Button';
import CustomInput from '../../components/common/CustomInput';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import { setStoredMacIDValue } from "../../_helpers/storageHelper";


const KioskSetup = () => {
  const { facilityDetails: facilities, podDetails: pods, kioskDetails: kiosks, verificationCodeValidate } = useSelector(state => state.kioskLogin);
  const [selectedFacility, setSelectedFacility] = useState('');
  const [selectedPod, setSelectedPod] = useState('');
  const [selectedKiosk, setSelectedKiosk] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [isValidateMachine, setisValidateMachine] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState({});
  const [preverificationCode, setpreverificationCode] = useState();
  const [ishidePassword, setishidePassword] = React.useState(true);

  const handleInputChange = (input) => {
    setVerificationCode(input?.toUpperCase()); setErrorMessage((prev) => ({ ...prev, verificationCode: "" }));
  };

  useEffect(() => {
    dispatch(kioskLoginActions.getfacilityDetails());
  }, []);

  useEffect(() => {
    if (selectedFacility) {
      dispatch(kioskLoginActions.getLoadPodDropDown(selectedFacility));
    }
  }, [selectedFacility]);

  useEffect(() => {
    if (selectedPod) {
      dispatch(kioskLoginActions.getLoadKioskDropDown({ selectedPod, selectedFacility }));
    }
  }, [selectedPod]);

  useEffect(() => {
    const invalidCodes = [-2, -3, -4, -5];
    if (invalidCodes.includes(verificationCodeValidate) && isValidateMachine) {
      setShowPopup(true);
    }
  }, [verificationCodeValidate, isValidateMachine]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage({});
    const { error } = kioskSetupSchema({ selectedFacility, selectedPod, selectedKiosk, verificationCode });
    if (error) {
      error.details.forEach((e) => {
        setErrorMessage((prev) => ({
          ...prev,
          [e.path.toString()]: e.message,
        }));
      });
      return;
    }
    dispatch(kioskLoginActions.getKiosksVerificationCodeValidate({ selectedFacility, selectedPod, selectedKiosk, verificationCode }))
    setisValidateMachine(true);
  };

  const handleVerify = async () => {
    dispatch(kioskLoginActions.getKiosksMacAddressValidate(verificationCode));
    dispatch(kioskLoginActions.getUpdateKiosksActiveStatus({ selectedKiosk, selectedFacility, verificationCode }))
    setShowPopup(true);
    setStoredMacIDValue('KIOKEY', verificationCode);
    navigate('/', { state: { showPopup: true } });
  }

  const handleCancel = () => {
    setVerificationCode(preverificationCode); setIsKeyboardOpen(false);
  }

  return (
    <div className="parent-container">
      {isKeyboardOpen ?
        <CustomKeyboard
          onInputChange={handleInputChange}
          inputValue={verificationCode}
          placeholder={"ENTER VERIFICATION CODE"}
          setShowBoard={setIsKeyboardOpen}
          handleCancel={handleCancel}
          isPassword={true}
          fromKioskSetup = {true}
          isSuggestionsEnabled={false}
        />
        :
        <div className="form-column">
          <img className='image' onClick={() => { navigate('/') }} src={logo} alt="Logo" />
          <div className="kiosk-setup-container">
            {(verificationCodeValidate == 1 && isValidateMachine) ? <div >
              <h4 className='verifySetup'>Verify Kiosk Setup</h4>
              <div className="details">
                <div className="verifyrow">
                  <div class="col-md-6 form-group d-flex flex-column align-items-start">
                    <label className="form-label verify-label">VALIDATED CODE</label>
                    <h3 className="text-center mb-0 text-default-red fw-700">{verificationCode}</h3>
                  </div>
                  <div className="col-md-6 form-group d-flex flex-column align-items-start">
                    <label className="form-label verify-label">FACILITY NAME</label>
                    <h3 className="text-center mb-0 text-default-red fw-700">
                      {facilities?.find(facility => facility?.value === selectedFacility)?.FacilityName?.toUpperCase()}
                    </h3>
                  </div>

                </div>
                <div className="verifyrow">
                  <div className="col-md-6 form-group d-flex flex-column align-items-start">
                    <label className="form-label verify-label">POD NAME</label>
                    <h3 className="text-center mb-0 text-default-red fw-700">{pods?.find(pod => pod?.value == selectedPod)?.label?.toUpperCase()}</h3>
                  </div>
                  <div className="col-md-6 form-group d-flex flex-column align-items-start">
                    <label className="form-label verify-label">KIOSK CODE</label>
                    <h3 className="text-center mb-0 text-default-red fw-700">{kiosks?.find(kiosk => kiosk?.value == selectedKiosk)?.label?.toUpperCase()}</h3>
                  </div>
                </div>
              </div>
              <div className="actions">
                <Button label="VERIFY" status="primary" type="submit" onClick={() => handleVerify()} />
                <Button label="CANCEL" status="secondary" type="button" onClick={() => navigate('/')} />
              </div>
            </div> :
              <div>
                <h2 className="verifySetup">Kiosk Setup</h2>
                <form className="kiosk-setup-form" >
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <SelectInput
                        options={facilities}
                        label="Choose Facility"
                        name="selectedFacility"
                        id="selectedFacility"
                        labelKey="label"
                        valueKey="value"
                        value={selectedFacility}
                        isClearable={false}
                        isSearchable={true}
                        required
                        isshowCaps={true}
                        placeholder="-- SELECT --"
                        handleChange={(e) => {
                          setSelectedFacility(e.value); setSelectedPod(''); setSelectedKiosk('')
                          setErrorMessage((prev) => ({ ...prev, selectedFacility: "" }));
                        }}
                        errorMessage={errorMessage}
                      />
                    </div>
                    <div className="col-md-6 mb-3" >
                      <SelectInput
                        options={pods}
                        isshowCaps={true}
                        label="Choose POD"
                        name="selectedPod"
                        id="selectedPod"
                        labelKey="label"
                        valueKey="value"
                        value={selectedPod}
                        isClearable={false}
                        isSearchable={true}
                        required
                        isDisabled={!selectedFacility}
                        placeholder={selectedFacility ? "-- SELECT --" : ''}
                        handleChange={(e) => {
                          setSelectedPod(e.value); setSelectedKiosk('');
                          setErrorMessage((prev) => ({ ...prev, selectedPod: "" }));
                        }}
                        errorMessage={errorMessage}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="mb-2">
                        <SelectInput
                          isshowCaps={true}
                          options={kiosks}
                          label="Choose Kiosk"
                          name="selectedKiosk"
                          id="selectedKiosk"
                          labelKey="label"
                          valueKey="value"
                          value={selectedKiosk}
                          isClearable={false}
                          required
                          isSearchable={true}
                          isDisabled={!selectedPod}
                          placeholder={selectedPod ? "-- SELECT --" : ''}
                          handleChange={(e) => {
                            setSelectedKiosk(e.value);
                            setErrorMessage((prev) => ({ ...prev, selectedKiosk: "" }));
                          }}
                          errorMessage={errorMessage}
                        />
                      </div></div>
                    <div className="col-md-6 mb-3">
                      <CustomInput
                        label={"Verification Code"}
                        // type={"text"}
                        type={ishidePassword ? "password" : "text"}
                        togglePasswordVisibility={() => { setishidePassword(!ishidePassword) }}
                        id="verificationCode"
                        value={verificationCode}
                        placeholder={"ENTER VERIFICATION CODE"}
                        onClick={() => { setIsKeyboardOpen(true); setpreverificationCode(verificationCode) }}
                        errorMessage={errorMessage.verificationCode}
                        required={true}
                      />
                    </div></div>
                  <div className="d-flex justify-content-center">
                    <Button
                      variant="primary"
                      className="me-2"
                      label="VALIDATE MACHINE"
                      type="submit"
                      status="primary"
                      disabled={false}
                      onClick={handleSubmit}
                    />
                  </div>
                </form>
              </div>
            }
          </div>
        </div>}
      {showPopup && <CustomModal content="Entered Verification code doesn't match" color={'#c8605e'} onOkClick={() => { setShowPopup(false); navigate('/') }} />}
    </div>
  );
};
export default memo(KioskSetup);